function pushDataLayer(data) {
  setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  });
}

export default function install(app) {
  app.config.globalProperties.$inertia.on('navigate', () => {
    pushDataLayer(function () {
      this.set('time', new Date());
    });
    pushDataLayer({
      event: 'Pageview',
      pagePath: window.location.pathname,
      pageTitle: window.document.title,
    });
  });
}
